import React, { useEffect, useRef, useState } from "react";

export function usePanelMotion(open, panelRef) {
  const skip = useRef(true);

  useEffect(() => {
    const panel = panelRef.current;
    if (!panel) return undefined;
    const inner = panel.firstElementChild;
    const full = () => (inner ? inner.scrollHeight : 0);

    if (skip.current) {
      skip.current = false;
      panel.style.height = open ? "auto" : "0px";
      return undefined;
    }

    panel.style.overflow = "hidden";
    if (open) {
      panel.style.height = "0px";
      const fullHeight = full();
      window.requestAnimationFrame(() => {
        panel.style.height = `${fullHeight}px`;
      });
      const finish = (event) => {
        if (event.propertyName !== "height") return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", finish);
      };
      panel.addEventListener("transitionend", finish);
      return () => panel.removeEventListener("transitionend", finish);
    }

    const current = panel.getBoundingClientRect().height;
    panel.style.height = `${current}px`;
    void panel.offsetHeight;
    panel.style.height = "0px";
    return undefined;
  }, [open, panelRef]);
}

function Fold({ open, children, className, title, hint, onToggle }) {
  const panelRef = useRef(null);
  usePanelMotion(open, panelRef);
  return (
    <div className={className}>
      <button type="button" className="dash-fold-head" aria-expanded={open} onClick={onToggle}>
        <span>
          {title}
          {hint ? <span className="dash-fold-hint">{hint}</span> : null}
        </span>
        <i className={`bi ${open ? "bi-chevron-up" : "bi-chevron-down"}`} aria-hidden="true" />
      </button>
      <div className="dash-fold-panel" ref={panelRef}>
        <div className="dash-fold-panel-inner">{children}</div>
      </div>
    </div>
  );
}

export function DashboardSection({ title, hint, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Fold
      open={open}
      className={`dash-fold ${open ? "is-open" : ""}`}
      title={<span className="dash-fold-title">{title}</span>}
      hint={hint}
      onToggle={() => setOpen((value) => !value)}
    >
      <div className="dash-fold-body">{children}</div>
    </Fold>
  );
}

export function ChartPanel({ title, children, className = "col-lg-12" }) {
  const [open, setOpen] = useState(true);
  return (
    <div className={`${className} commTopButtonRightLeftPadding`}>
      <Fold
        open={open}
        className={`card dash-chart-card ${open ? "is-open" : ""}`}
        title={<h5 className="card-title mb-0">{title}</h5>}
        onToggle={() => setOpen((value) => !value)}
      >
        <div className="card-body dash-chart-body">{children}</div>
      </Fold>
    </div>
  );
}
